"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardPhotoFooter = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardPhotoFooterMixin = require("../../mixins/components/PropertyCardPhotoFooterMixin");
var StyledPropertyCardPhotoFooter = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardPhotoFooter",
  componentId: "c11n-8-107-0__sc-12lm4o3-0"
})(["", ""], _PropertyCardPhotoFooterMixin.PropertyCardPhotoFooterMixin);
exports.StyledPropertyCardPhotoFooter = StyledPropertyCardPhotoFooter;